import { trustStats } from '@/mocks/categories';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20featuring%20soft%20warm%20terracotta%20coral%20and%20cream%20gradients%20flowing%20together%2C%20delicate%20geometric%20line%20patterns%20in%20champagne%20gold%2C%20modern%20editorial%20fashion%20backdrop%2C%20luxurious%20minimalist%20aesthetic%2C%20subtle%20textile%20inspired%20textures%20throughout%2C%20sophisticated%20retail%20atmosphere%20vibe%2C%20elegant%20warm%20lighting%20effect%2C%20no%20text%20no%20people&width=1600&height=900&seq=hero-main-bg-v2-2026&orientation=landscape"
          alt="Pandabuy Spreadsheet fashion finds background"
          className="w-full h-full object-cover object-center"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight tracking-tight">
            Best Pandabuy Spreadsheet 2026
          </h1>
          <p className="mt-4 md:mt-6 text-base md:text-lg text-white/85 max-w-2xl mx-auto leading-relaxed">
            Discover thousands of verified fashion finds, shoes, clothing, accessories and budget picks — all organized in one place.
          </p>
          <p className="mt-3 text-sm md:text-base text-white/65 max-w-xl mx-auto">
            The largest Pandabuy Spreadsheet directory for sneakers, clothing, bags, and hidden finds.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-external-link-line mr-2"></i>
              Explore Spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold text-foreground-950 bg-white/90 hover:bg-white rounded-lg transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-shopping-bag-3-line mr-2"></i>
              Buy It Now
            </a>
          </div>

          <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {trustStats.map((stat) => (
              <div key={stat.label} className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-white">{stat.value}</p>
                <p className="text-xs md:text-sm text-white/65 mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <a
          href="#categories"
          className="flex items-center gap-2 text-white/60 hover:text-white/90 text-sm transition-colors cursor-pointer"
        >
          <span>Browse Categories</span>
          <i className="ri-arrow-down-line animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}